module.exports = "/images/fbSocial.png?4e20a197fce2e4fd840663cc644457b1";